// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input-module__root--HDkAU {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 54px;
  align-items: center;
  border: 1px solid var(--chaek-color-surface-subtle);
  border-radius: 15px;
  background-color: var(--chaek-color-surface-subtle);
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.5004px;
}

.Input-module__root--HDkAU:focus-within {
  border-color: var(--chaek-color-border-strong);
}

.Input-module__root--HDkAU:has(> input:disabled) {
  opacity: 0.4;
}

.Input-module__root--HDkAU > input {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
}

.Input-module__root--HDkAU > input::placeholder {
  color: var(--chaek-color-text-placeholder);
  font-weight: 400;
}

.Input-module__root--HDkAU > input {
  padding-inline: 16px;
}

.Input-module__root--HDkAU > .Input-module__leading--yckB5,
.Input-module__root--HDkAU > .Input-module__trailing--uDetU {
  position: absolute;
  top: 50%;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
}

.Input-module__root--HDkAU > .Input-module__leading--yckB5 {
  left: 15px;
}

.Input-module__root--HDkAU > .Input-module__trailing--uDetU {
  right: 15px;
}

.Input-module__has-leading--uSsAE > input {
  padding-left: 43px;
}

.Input-module__has-trailing--ew8CK > input {
  padding-right: 43px;
}

.Input-module__is-reverse--gIMr3 {
  border-color: rgb(255 255 255 / 15%);
  background-color: rgb(255 255 255 / 8%);
  color: #fff;
}

.Input-module__is-reverse--gIMr3 > input::placeholder {
  color: var(--chaek-color-text-source-bdbdbd);
}

.Input-module__size-small--NdifC {
  box-sizing: border-box;
  height: 44px;
  font-size: 0.8125rem; /* 13px */
}

.Input-module__size-medium--MAmUL {
  box-sizing: border-box;
  height: 50px;
  font-size: 0.875rem; /* 14px */
}

.Input-module__size-large--CFzXe {
  box-sizing: border-box;
  height: 56px;
  font-size: 0.9375rem; /* 15px */
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Input/Input.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,mBAAmB;EACnB,mDAAmD;EACnD,sCAAsC;EACtC,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB,EAAE,SAAS;AACjC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB,EAAE,SAAS;AACjC","sourcesContent":[".root {\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  height: 54px;\n  align-items: center;\n  border: 1px solid var(--chaek-color-surface-subtle);\n  border-radius: 15px;\n  background-color: var(--chaek-color-surface-subtle);\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: -0.5004px;\n}\n\n.root:focus-within {\n  border-color: var(--chaek-color-border-strong);\n}\n\n.root:has(> input:disabled) {\n  opacity: 0.4;\n}\n\n.root > input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n}\n\n.root > input::placeholder {\n  color: var(--chaek-color-text-placeholder);\n  font-weight: 400;\n}\n\n.root > input {\n  padding-inline: 16px;\n}\n\n.root > .leading,\n.root > .trailing {\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-50%);\n}\n\n.root > .leading {\n  left: 15px;\n}\n\n.root > .trailing {\n  right: 15px;\n}\n\n.has-leading > input {\n  padding-left: 43px;\n}\n\n.has-trailing > input {\n  padding-right: 43px;\n}\n\n.is-reverse {\n  border-color: rgb(255 255 255 / 15%);\n  background-color: rgb(255 255 255 / 8%);\n  color: #fff;\n}\n\n.is-reverse > input::placeholder {\n  color: var(--chaek-color-text-source-bdbdbd);\n}\n\n.size-small {\n  box-sizing: border-box;\n  height: 44px;\n  font-size: 0.8125rem; /* 13px */\n}\n\n.size-medium {\n  box-sizing: border-box;\n  height: 50px;\n  font-size: 0.875rem; /* 14px */\n}\n\n.size-large {\n  box-sizing: border-box;\n  height: 56px;\n  font-size: 0.9375rem; /* 15px */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Input-module__root--HDkAU`,
	"leading": `Input-module__leading--yckB5`,
	"trailing": `Input-module__trailing--uDetU`,
	"has-leading": `Input-module__has-leading--uSsAE`,
	"has-trailing": `Input-module__has-trailing--ew8CK`,
	"is-reverse": `Input-module__is-reverse--gIMr3`,
	"size-small": `Input-module__size-small--NdifC`,
	"size-medium": `Input-module__size-medium--MAmUL`,
	"size-large": `Input-module__size-large--CFzXe`
};
export default ___CSS_LOADER_EXPORT___;
